<template>
  <div class="pages-cooperative">
    <div class="the-banner"></div>
    <div class="bgbox-white">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="wow slideInUp">
          <div class="module-title">
            <span class="title-cn">神行者营销合作模式</span>
            <span class="title-en">MARKETING COOPERATION MODEL</span>
          </div>
          <p class="module1-text">神行者真诚的欢迎合作伙伴加入，我们坚持以渠道销售为主，公司在不断向市场推出新产品新技术的同时，我们也同时向合作伙伴提供充足的市场销售宣传支持和产品技术培训以及完善的售后服务。为了建立高效、规范的销售体系。为了使我们的合作伙伴有更大的利润空间、更多的成长机会，公司对现有的国内市场销售体系采取三级渠道分销和特殊行业代理制度，即<span>核心代理（1级代理）、地市级代理（2级代理理）、经销商代理（3级代理）和特殊行业代理（2级代理）</span>。</p>
        </div>
      </el-col>
    </div>
    <div class="bgbox-gray">
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="module-title">
          <span class="title-cn">全国服务网点</span>
          <span class="title-en">SERVICE OUTLETS</span>
          <p>客服热线：400-048-1488</p>
        </div>
        <div class="module2-conts">
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:15}">
            <div class="region-box wow slideInLeft">
              <div class="line">
                <span class="item blue">华中地区</span>
                <span class="item">河南省</span>
                <span class="item gray">湖南省</span>
                <span class="item">贵州省</span>
                <span class="item gray">江西省</span>
              </div>
              <div class="line">
                <span class="item blue">华北地区</span>
                <span class="item gray">北京市</span>
                <span class="item">天津市</span>
                <span class="item gray">山西省</span>
                <span class="item">山东省</span>
                <span class="item gray">内蒙古</span>
              </div>
              <div class="line">
                <span class="item blue">西北地区</span>
                <span class="item">陕西省</span>
                <span class="item gray">青海省</span>
                <span class="item">宁夏省</span>
              </div>
              <div class="line">
                <span class="item blue">东北地区</span>
                <span class="item gray">黑龙江省</span>
                <span class="item">吉林省</span>
                <span class="item gray">辽宁省</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:9}">
            <div class="contact-box">
              <p class="title">业务合作请联系：</p>
              <p class="line1"><span class="name">胡海</span><span class="tel">185-2824-9666</span></p>
              <p class="line2"><a target="_blank" href="tencent://message/?uin=3003582481&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3003528119:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
               </div>
          </el-col>
        </div>
        <div class="module2-conts">
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:15}">
            <div class="region-box">
              <div class="line">
                <span class="item blue">华东地区</span>
                <span class="item">上海市</span>
                <span class="item gray">江苏省</span>
                <span class="item">浙江省</span>
                <span class="item gray">安徽省</span>
                <span class="item">福建省</span>
              </div>
              <div class="line">
                <span class="item blue">华南地区</span>
                <span class="item gray">广东省</span>
                <span class="item">海南省</span>
                <span class="item gray">广西省</span>
              </div>
              <div class="line">
                <span class="item blue">西南地区</span>
                <span class="item">重庆市</span>
                <span class="item gray">四川省</span>
                <span class="item">云南省</span>
                <span class="item gray">西藏</span>
              </div>
              <div class="line">
                <span class="item blue">其他地区</span>
                <span class="item gray">河北省</span>
                <span class="item">新疆省</span>
                <span class="item gray">甘肃省</span>
              </div>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:9}">
            <div class="contact-box wow slideInDown">
              <p class="title">业务合作请联系：</p>
              <p class="line1"><span class="name">赵美美</span><span class="tel">188-7400-1568</span></p>
              <p class="line2"><a target="_blank" href="tencent://message/?uin=3003533057&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3003528119:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
            </div>
          </el-col>
        </div>
        <div class="module2-conts">
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:14}" :lg="{span:15}">
            <div class="custom-box">
              <p class="line1">神行者行业定制</p>
              <p class="line2">为多行业提供<span>简单、高效、稳定的网络优化解决方案</span></p>
            </div>
          </el-col>
          <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:10}" :lg="{span:9}">
            <div class="contact-box wow slideInRight">
              <p class="title">合作洽谈：</p>
              <p class="line1"><span class="name">赵美美</span><span class="tel">188-7400-1568</span></p>
              <p class="line2"><a target="_blank" href="tencent://message/?uin=1430000006&amp;Menu=yes"><img border="0" src="http://wpa.qq.com/pa?p=2:3003528119:51" alt="点击这里给我发消息" title="点击这里给我发消息"/></a></p>
            </div>
          </el-col>
        </div>
      </el-col>
    </div>
    <div class="bgbox-white">
      <div class="module-title">
        <span class="title-cn">渠道层级</span>
        <span class="title-en">CHANNEL LEVEL</span>
      </div>
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:24}" :lg="{span:8}">
          <div class="module3-item wow slideInLeft">
            <div class="conts">
              <div class="title">
                <span>1</span>
                <p>核心代理商</p>
              </div>
              <p class="line1">核心代理商（1级代理）加盟条件</p>
              <p class="line2">1、必须是合法成立的一般纳税人企业，主营业务性质和客户与代理的产品有关。</p>
              <p class="line2">2、资深网络设备分销渠道；渠道管理经验丰富；较强资金实力。</p>
              <p class="line2">3、具备二名以上的网络技术人员，指导客户安装使用，并能为客户提供一定技术与方案支持；至少能有二人专职负责产品的市场销售工作。</p>
              <p class="line2">4、愿意遵守神行者的的销售政策、价格体系及管理制度，并能完成公司下达的销售任务。</p>
              <p class="line2">5、能定期提供代理工作计划与总结文件。</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
          <div class="module3-item wow slideInUp">
            <div class="conts">
              <div class="title">
                <span>2</span>
                <p>金牌代理商</p>
              </div>
              <p class="line1">金牌代理商（2级代理）加盟条件</p>
              <p class="line2">1、必须是合法成立的企业，主营业务性质和客户与代理的产品有关联，具有一定的市场开拓能力和管理经验。</p>
              <p class="line2">2、应具备一名以上的网络技术人员，指导客户安装使用，并能为客户提供一定技术支持；至少能有一人专职负责产品的市场销售工作。</p>
              <p class="line2">3、愿意遵守神行者产品的销售政策、价格体系及管理制度，并能完成公司下达的销售任务。</p>
              <p class="line2">4、能定期提供代理工作计划与总结文件。</p>
            </div>
          </div>
        </el-col>
        <el-col :xs="{span:24}" :sm="{span:12}" :md="{span:12}" :lg="{span:8}">
          <div class="module3-item wow slideInRight">
            <div class="conts">
              <div class="title">
                <span>3</span>
                <p>经销代理商</p>
              </div>
              <p class="line1">经销代理商（3级代理）加盟条件</p>
              <p class="line2">1、了解本公司的产品性能，能够正确的指导客户安装和使用本公司产品。</p>
              <p class="line2">2、主力推荐神行者产品。</p>
              <p class="line2">3、较强的学习能力；能认同神行者品牌价值观念。</p>
            </div>
          </div>
        </el-col>
      </el-col>
    </div>
    <div class="bgbox-white">
      <div class="module-title">
        <span class="title-cn">渠道体系支持</span>
        <span class="title-en">CHANNEL SYSTEM SUPPORT</span>
      </div>
      <el-col :xs="{span:24}" :sm="{span:24}" :md="{span:20,offset:2}" :lg="{span:16,offset:4}">
        <div class="table-box">
          <table border="0" cellspacing="0" cellpadding="0" align="center">
            <thead>
              <tr>
                <th colspan="2">项目支持</th>
                <th>核心代理商/金牌代理商</th>
                <th>经销代理商</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td rowspan='3' class="gray title">市场支持</td>
                <td>市场活动</td>
                <td>✔</td>
                <td></td>
              </tr>
              <tr>
                <td class="gray">礼品赞助</td>
                <td class="gray">✔</td>
                <td class="gray"></td>
              </tr>
              <tr>
                <td>宣传资料</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td rowspan='3' class="title">管理支持</td>
                <td class="gray">项目保护</td>
                <td class="gray">✔</td>
                <td class="gray">✔</td>
              </tr>
              <tr>
                <td>项目管理</td>
                <td>✔</td>
                <td></td>
              </tr>
              <tr>
                <td class="gray">渠道秩序维护</td>
                <td class="gray">✔</td>
                <td class="gray"></td>
              </tr>
              <tr>
                <td rowspan='3' class="gray title">培训认证</td>
                <td>产品培训</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td class="gray">销售培训</td>
                <td class="gray">✔</td>
                <td class="gray">✔</td>
              </tr>
              <tr>
                <td>技术培训</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td rowspan='3' class="title">服务支持</td>
                <td class="gray">硬件保修</td>
                <td class="gray">✔</td>
                <td class="gray">✔</td>
              </tr>
              <tr>
                <td>软件升级</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td class="gray">400免费服务</td>
                <td class="gray">✔</td>
                <td class="gray">✔</td>
              </tr>
              <tr>
                <td rowspan='8' class="gray title">销售激励</td>
                <td>优惠折扣</td>
                <td>✔</td>
                <td></td>
              </tr>
              <tr>
                <td class="gray">销售返点</td>
                <td class="gray">✔</td>
                <td class="gray"></td>
              </tr>
              <tr>
                <td>特殊奖励</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td class="gray">演示平台</td>
                <td class="gray">✔</td>
                <td class="gray">✔</td>
              </tr>
              <tr>
                <td>人员支持</td>
                <td>✔</td>
                <td></td>
              </tr>
              <tr>
                <td class="gray">商机支持</td>
                <td class="gray">✔</td>
                <td class="gray"></td>
              </tr>
              <tr>
                <td>样板客户参观</td>
                <td>✔</td>
                <td>✔</td>
              </tr>
              <tr>
                <td class="gray">公司参观</td>
                <td class="gray">✔</td>
                <td class="gray">✔</td>
              </tr>
            </tbody>
          </table>
        </div>
      </el-col>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>
<style lang="scss" scoped>
.bgbox-white{
  padding: 50px 10px;
  overflow: hidden;
  background: #fff;
  box-sizing: border-box;
}
.bgbox-gray{
  padding: 50px 10px;
  overflow: hidden;
  background: #f7f7f7;
}
.the-banner {
  height: 400px;
  background-image: url("../../assets/images/cooperative-banner1.jpg");
  background-repeat: no-repeat;
  background-position: center;
}
.module-title{
  text-align: center;
  padding-bottom: 40px;
  .title-cn{
    display: block;
    font-size: 30px;
    font-weight: bold;
    color: #1f1f1f;
  }
  .title-en{
    display: block;
    font-size: 12px;
    font-weight: 400;
    color: #757575;
    line-height: 20px;
  }
}
.module1-text{
  font-size: 14px;
  color: #1f1f1f;
  text-indent: 2em;
  span{
    color: #0066cc;
  }
}
.module2-conts{
  padding: 30px 20px;
  box-sizing: border-box;
  overflow: hidden;
  background: #fff;
  margin-bottom: 20px;
  .region-box{
    width: 100%;
    .line{
      width: 100%;
      overflow: hidden;
      box-sizing: border-box;
      .item{
        display: block;
        float: left;
        width: 106px;
        height: 40px;
        margin-right: 10px;
        margin-bottom: 10px;
        background: #fff;
        font-size: 16px;
        color: #1f1f1f;
        border: 1px solid #cccccc;
        box-sizing: border-box;
        text-align: center;
        line-height: 40px;
        &.blue{
          background: #3067ba;
          border-color: #3067ba;
          color: #fff;
        }
        &.gray{
          background: #f5f5f5;
        }
      }
    }
  }
  .custom-box{
    width: 100%;
    .line1{
      font-size: 18px;
      color: #333;
      margin-bottom: 30px;
    }
    .line2{
      font-size: 22px;
      color: #000;
      font-weight: bold;
      span{
        color: #3067ba;
      }
    }
  }
  .contact-box{
    .title{
      font-size: 18px;
      color: #757575;
      margin-bottom: 30px;
    }
    .line1{
      margin-bottom: 20px;
      line-height: 20px;
      .name{
        width: 70px;
        font-size: 16px;
        color: #1f1f1f;
        display: inline-block;
      }
      .tel{
        font-size: 18px;
        color: #3067ba;
        padding-left: 30px;
        box-sizing: border-box;
        background-image: url("../../assets/images/icon-tel2.png");
        background-size: 18px;
        background-repeat: no-repeat;
        background-position: left center;
      }
    }
    .line2{
      padding-left: 70px;
      margin-bottom: 30px;
      &:last-child{
        margin-bottom: 0;
      }
    }
  }
}
.module3-item{
  max-width: 400px;
  margin: 0 auto;
  padding: 10px;
  box-sizing: border-box;
  .conts{
    border: 1px solid #e6e6e6;
    padding: 20px;
    box-sizing: border-box;
    min-height: 400px;
    transition: all 0.3s ease-in;
    &:hover{
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      transform: translate3d(0,-2px,0);
      background: rgba(124, 215, 243, 0.2);
    }
    .title{
      height: 130px;
      text-align: center;
      span{
        display: inline-block;
        width: 80px;
        height: 60px;
        background-image: url("../../assets/images/icon-rank.png");
        background-repeat: no-repeat;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        line-height: 50px;
        margin-bottom: 30px;
      }
      p{
        font-size: 18px;
        color: #0066cc;
      }
    }
    .line1{
      font-size: 14px;
      color: #000;
      margin-bottom: 10px;
    }
    .line2{
      font-size: 12px;
      color: #757575;
      line-height: 20px;
    }
  }
}
.table-box {
    width: 100%;
    overflow-x: scroll;
    padding-bottom: 5px;
    box-sizing: border-box;
    table {
      width: 100%;
      border-right: 1px solid #fff;
      border-bottom: 1px solid #fff;
      border-spacing: 0;
      border-collapse: collapse;
      box-sizing: border-box;
      th {
        font-weight: 700;
        min-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        border-left: 1px solid #fff;
        border-top: 1px solid #fff;
        height: 50px;
        background: #3067ba;
        font-size: 18px;
        color: #fff;
        text-align: center;
        box-sizing: border-box;
        padding: 5px!important;
      }
      td {
        font-weight: 400;
        overflow: hidden;
        text-overflow: ellipsis;
        border-left: 1px solid #fff;
        border-top: 1px solid #fff;
        height: 50px;
        background: #fff;
        font-size: 16px;
        color: #1f1e1e;
        text-align: center;
        box-sizing: border-box;
        padding: 5px!important;
        &.gray {
          background: #f5f5f5;
        }
        &.title {
          font-size: 18px;
          color: #1f1f1f;
          font-weight: bold;
        }
      }
    }
}
.table-box::-webkit-scrollbar {
    width: 6px;
    height: 6px
}
.table-box::-webkit-scrollbar-thumb {
    background-color: #999;
    border-radius: 6px
}
// 移动端css
@media screen and (max-width: 767px) {
  .the-banner{
    height: 260px;
    background-image: url("../../assets/images/cooperative-banner2.jpg");
  }
  .module3-item{
    padding: 10px 0;
    .conts{
      padding: 10px;
    }
  }
}
</style>